import type {
  CreateContractRequest,
  EditContractRequest,
} from 'shared/domain/messages/contract/eventMessages';
import { Services } from 'shared/domain/messages/message';
import { getAndBroadcastAllContracts } from 'serviceWorker/broadcasts/contract/all';
import * as contracts from 'serviceWorker/db/contracts/contracts';
import * as contractsService from 'serviceWorker/db/contracts/contractsService';
import { debugLog } from 'shared/logger/debugLog';
import { contractSaver } from './addContract';
import { contractEditor } from './editContract';
import { fetchContracts, fetchUpdatedContracts } from './fetchContracts';
import { contractChannelContract } from 'shared/domain/contract/contractChannelContract';
import { createSyncedEntity } from '../factories/createSyncedEntity';

/** Download and sync of the contracts; the source's `sync` is its entry point. */
export const contractsSync = createSyncedEntity({
  entityName: Services.CONTRACTS,
  contract: contractChannelContract,
  repository: contracts,
  service: contractsService,
  fetch: fetchContracts,
  fetchUpdated: fetchUpdatedContracts,
  publishCollection: getAndBroadcastAllContracts,
});

/**
 * Resolves once the change is in the HTTP queue and rejects only when it could
 * not be queued. The server's answer follows as an event (`createdEntity`,
 * `failUploadedEntity`, …) with the change's `uniqueId`.
 */
export function handleAddContract(detail: CreateContractRequest): Promise<void> {
  debugLog('addContract', detail);
  return contractSaver.execute(detail.contractCreateModel, detail.uniqueId);
}

export function handleEditContract(detail: EditContractRequest): Promise<void> {
  debugLog('editContract', detail);
  return contractEditor.execute(detail.contractEditModel, detail.uniqueId);
}
